// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__30ZB5","spacer":"styles_spacer__1UcyX"};